<template>
  <div class="recruit-container">
    <h2 class="page-title">人才招募</h2>
    <div class="recruitment-page">
      <div class="sidebar">
        <div class="sidebar-menu">
          <button v-for="category in categories" :key="category.id" @click="selectCategory(category.id)"
            :class="['category-button', { active: selectedCategory === category.id }]">
            {{ category.name }}
          </button>
        </div>
      </div>
      <div class="main-content">
        <div v-if="loading" class="loading-message">資料加載中...</div>
        <div v-else>
          <div v-if="filteredJobs.length === 0" class="no-data-message">目前沒有此類別的職缺。</div>
          <div v-for="job in filteredJobs" :key="job.id" class="job-card">
            <h3>{{ job.title }}</h3>
            <button class="view-button" @click="viewDetails(job.link)">查看</button>
          </div>
        </div>
      </div>
    </div>
    <ContactFooter />
  </div>
</template>

<script>
import ContactFooter from '@/components/ContactFooter.vue';
import PullDAO from '@/services/PullDAO'; // Import PullDAO

export default {
  name: 'RecruitmentPage',
  components: {
    ContactFooter,
  },
  data() {
    return {
      loading: true, // Loading state
      selectedCategory: 'all',
      categories: [
        { id: 'all', name: '全部職缺' },
        { id: '停車場管理員', name: '停車場管理員' },
        { id: '客服人員', name: '客服人員' },
        { id: '行政人員', name: '行政人員' },
        { id: '總務人員', name: '總務人員' },
        { id: '資訊人員', name: '資訊人員' },
        { id: '開發業務', name: '開發業務' },
        { id: '其他人員', name: '其他人員' },

 
      ],
      jobs: [], // Job list fetched from PullDAO
    };
  },
  computed: {
    filteredJobs() {
      if (this.selectedCategory === 'all') {
        return this.jobs;
      }
      return this.jobs.filter(job => job.category === this.selectedCategory);
    },
  },
  methods: {
    async fetchJobs() {
      const pullDAO = new PullDAO();
      try {
        this.loading = true; // Start loading
        const response = await pullDAO.listRecruits(10, 1); // Fetch 10 jobs, page 1
        console.log('Fetched recruit jobs:', response);
        this.jobs = response.recruits; // Assuming `response.data` contains the job list
      } catch (error) {
        console.error('Error fetching recruit jobs:', error);
        this.jobs = []; // Reset jobs in case of error
      } finally {
        this.loading = false; // End loading
      }
    },
    selectCategory(categoryId) {
      this.selectedCategory = categoryId;
    },
    viewDetails(link) {
      console.log('Opening link:', link);
      window.open(link, '_blank');
    },
  },
  async mounted() {
    await this.fetchJobs(); // Fetch job data when the component is mounted
  },
};
</script>

<style scoped>
.recruit-container {
  width: 100%;
  background-color: var(--background-gray);
  /* min-height: 200vh; */
  /* padding-bottom: 5rem; */
}



.recruitment-page {
  display: flex;
  max-width: 1416px;
  margin: 0 auto;
  padding: 20px;
  min-height: 90vh;
}

.sidebar {
  width: 200px;
  padding-right: 20px;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.category-button {
  background-color: transparent;
  color: var(--green03);
  margin-bottom: 24px;
  border: none;
  cursor: pointer;

  padding: 6px 12px 6px 12px;
  border-radius: 8px ;



  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


}

.category-button.active {
  background-color: var(--green03);
  color: white;

  font-weight: 700;
}

.main-content {
  flex: 1;
}

.job-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 1rem 2rem;
  margin-bottom: 1.5rem;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 1.2rem;
  width: 1176px;
  height: 120px;



  box-sizing: border-box;
}

.job-card h3 {
  margin: 0;
  flex: 1;
  text-align: left;
  /* Ensures text is left-aligned */

  /* //styleName: 2xl/bold; */
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

}

.view-button {
  background-color: var(--green03);
  color: white;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  /* Adds space between text and button */

  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  /* //styleName: lg/bold; */
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


}

.view-button:hover {
  background-color: #008f5b;
}

/* Responsive design for smaller screens */
@media (max-width: 560px) {
  .recruitment-page {
    flex-direction: column;
    width: 343px;
    margin: 0 auto;
    padding: 0;
  }

  .sidebar {
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding: 10px 0;
  }

  .sidebar-menu {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .category-button {
    font-size: 1rem;
    padding: 6px 12px;
    margin: 4px;
    width: auto;

    /* //styleName: md/regular; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .main-content {
    padding: 0;
  }

  .job-card {
    flex-direction: row;
    width: 343px;
    height: 112px;
    padding: 1rem;

    margin-bottom: 20px;

  }

  .job-card h3 {
    margin-right: 10px;
    flex: 1;
    text-align: left;
    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .view-button {
    width: auto;
    padding: 10px 20px;

    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
}
</style>
